export const model = {
    id: null,
    number: "",
    parent_id: "",
    organization_id: "",
    begin_date: "",
    end_date: "",
    sum: "",
    remainder: "",
    status_id: "",
    comment: "",
    created_at: "",
    updated_at: "",
};
